import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
// import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  headerToken: 'test',
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request 拦截器
// service.interceptors.request.use(config => {
//   if (getToken()) {
//     console.log('getToken', getToken())
//     config.headers['Authorization'] = 'getToken()' // 让每个请求携带自定义token 请根据实际情况自行修改
//   }
//   return config
// }, error => {
//   // Do something with request error
//   console.log(error) // for debug
//   Promise.reject(error)
// })

// respone 拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js